import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useAuth } from "../../hooks/useAuth";

const PartnerDetails = ({ data, setShow }) => {
  const parseArray = (value) => {
    try {
      const list = JSON.parse(value);
      return Array.isArray(list) ? list.filter(Boolean) : [];
    } catch {
      return [];
    }
  };

  const renderField = (label, value) =>
    value ? (
      <p>
        <strong>{label}:</strong> {value}
      </p>
    ) : null;

  const renderList = (label, rawValue) => {
    const items = parseArray(rawValue);
    return items.length ? (
      <div className="mb-2">
        <strong>{label}:</strong>
        <ul className="mb-0 mx-4">
          {items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
    ) : null;
  };

  return (
    <Modal
      onHide={() => setShow(false)}
      show={true}
      dialogClassName="new-entity-modal"
      backdropClassName={`global-backdrop`}
      centered={true}
      animation={false}
      enforceFocus={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h1> Partner Details </h1>
          <p className="my-2">View partner details.</p>
          <p>Company Id: {" " + data.companyID}</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container py-4">
          <div className="row">
            {/* Company Info */}
            <div className="col-md-6 mb-3">
              <h5 className="mb-4">Company Information</h5>
              {renderField("Company ID", data.companyID)}
              {renderField("Company Name", data.company_name)}
              {renderField("Website", data.company_website)}
              {renderField("Email", data.company_email)}
              {renderField("Address Line 1", data.address_line_1)}
              {renderField("Address Line 2", data.address_line_2)}
              {renderField("City", data.city)}
              {renderField("State", data.state)}
              {renderField("Country", data.country)}
              {renderField("ZIP Code", data.zip_code)}
            </div>

            {/* Contact Info */}
            <div className="col-md-6 mb-3">
              <h5 className="mb-4">Contact Person</h5>
              {renderField("Title", data.title)}
              {renderField("Full Name", `${data.first_name} ${data.last_name}`)}
              {renderField("Personal Email", data.personal_email)}
              {renderField("Phone", `${data.country_code} ${data.phone_line}`)}
            </div>

            {/* Business Info */}
            <div className="row mb-3">
              <h5 className="mb-4">Business Information</h5>
              <div className="col-md-6">
                {renderList("Core Focus", data.core_focus)}
                {renderList("Solutions", data.solution)}
                {renderList("Industries", data.industry)}
                {renderList("Resell Partners", data.resell)}
              </div>
              <div className="col-md-6">
                {renderField("Business Size", data.business_size)}
                {renderField("Annual Revenue", data.annual_revenue)}
                {renderField("Why Interested", data.why_interested)}
                <p>
                  <strong>Verified:</strong> {data.is_verified ? "Yes" : "No"}
                </p>
                {renderField(
                  "Created At",
                  new Date(data.createdAt).toLocaleString()
                )}
                <div className="my-4 documents">
                  <RenderDocument data={data} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PartnerDetails;

const RenderDocument = ({ data }) => {
  const { backendUrl } = useAuth();
  if (!data.documents) {
    return <p>No documents uploaded.</p>;
  } else {
    console.log(data.documents);
    if (!Array.isArray(data.documents))
      data.documents = JSON.parse(data.documents);
    if (!data.documents.length) {
      return <p>No documents uploaded.</p>;
    }
  }

  return (
    <div className="mb-3">
      <h5>Uploaded Documents</h5>
      <ul className="list-group">
        {data.documents.map((doc, index) => (
          <li
            key={index}
            className="list-group-item d-flex justify-content-between align-items-center"
          >
            <span>{doc.name || `Document ${index + 1}`}</span>
            {doc.src && (
              <Button
                variant="primary"
                size="sm"
                onClick={() => {
                  window.open(
                    `${backendUrl}/api/accounts/partner/view-document/${
                      data.companyID
                    }/${doc.src.split("/").pop()}`,
                    "_blank"
                  );
                }}
              >
                {["xls", "xlsx", "ods"].includes(doc.src.split(".").pop())
                  ? "Download"
                  : "View"}
              </Button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
